$(document).ready(function(){

    let applyUtmParameters = () => {
         const utmSourceInput = document.querySelector('input[value="{{-utm.source-}}"]');
        const utmTermInput = document.querySelector('input[value="{{-utm.term-}}"]');
        const utmMediumInput = document.querySelector('input[value="{{-utm.medium-}}"]');
      const utmContentInput = document.querySelector('input[value="{{-utm.content-}}"]');
      
        try {
            // Get the current URL's query parameters
            const urlParams = new URLSearchParams(window.location.search);
      
            // Check for utm_source parameter
            const utmSource = urlParams.get('utm_source');
            if (utmSource) {
                console.log(`source: ${utmSource}`);
                // Check if the input element exists and its current value matches the expected default "website"
                if (utmSourceInput && utmSourceInput.value === '{{-utm.source-}}') {
                    utmSourceInput.value = utmSource;
                }else {
                    utmSourceInput.value = '';
                }
            }
      
            // Check for utm_term parameter
            const utmTerm = urlParams.get('utm_term');
            if (utmTerm) {
                console.log(`term: ${utmTerm}`);
                // Check if the input element exists and its current value matches the expected default "gf"
                if (utmTermInput && utmTermInput.value === '{{-utm.term-}}') {
                    utmTermInput.value = utmTerm;
                }else {
                    utmTermInput.value = '';
                }
            }
  
            // Check for utm_content parameter
            const utmContent = urlParams.get('utm_content');
            if (utmContent) {
                console.log(`content: ${utmContent}`);
                // Check if the input element exists and its current value matches the expected default "gf"
                if (utmContentInput && utmContentInput.value === '{{-utm.content-}}') {
                    utmContentInput.value = utmContent;
                }else {
                    utmContentInput.value = '';
                }
            }
      
            // Check for utm_medium parameter
            const utmMedium = urlParams.get('utm_medium');
            if (utmMedium) {
                console.log(`medium: ${utmMedium}`);
                // Check if the input element exists and its current value matches the expected default "org"
                if (utmMediumInput && utmMediumInput.value === '{{-utm.medium-}}') {
                    utmMediumInput.value = utmMedium;
                }else {
                    utmMediumInput.value = '';
                }
            }
        } catch (error) {
            console.error("Error parsing URL or updating inputs:", error);
        } 
    }
  
  
    const checkFormInterval = setInterval(() => {
              // Check if the element with class "globo-formbuilder-wizard" exists
              const formWizardElement = document.querySelector('.globo-formbuilder-wizard');
  
              if (formWizardElement) {
                  // If found, clear the interval to stop checking
                  clearInterval(checkFormInterval);
                  // Then execute the function to apply UTM parameters
                  applyUtmParameters();
                  console.log('Found .globo-formbuilder-wizard. Applying UTM parameters.');
              } else {
                  console.log('Waiting for .globo-formbuilder-wizard...');
                  // Optional: You can add a timeout here to stop checking after a certain period
                  // if (Date.now() - startTime > MAX_WAIT_TIME) { clearInterval(checkFormInterval); }
              }
          }, 500); // Check every 500 milliseconds (0.5 seconds)
  
    
  });